<div class="main-page-content">
  <div class="main-page-content-block">
    <div class="float-end">
      <p *ngIf="loading" role="status">Loading features and settings...</p>
    </div>

    <h1 class="content-heading-font">{{ currentClient?.BusinessName ||'Client' }} Features & Settings</h1>
    <p *ngIf="!loading && featureStatuses && !featureStatuses.length">No features information is available.</p>

    <div class="row mb-5" *ngIf="(featureStatuses && featureStatuses.length)">
      <div class="col-12 col-lg-5">
        <label for="feature">Feature</label>
        <select id="feature" class="form-select mb-3" [(ngModel)]="currentFeatureStatus"
                (ngModelChange)="selectFeature($event)" [disabled]="loading">
          <option [ngValue]="null">Please select a feature</option>
          <option *ngFor="let feature of featureStatuses" [ngValue]="feature">
            {{feature.FeatureName}} {{feature.TurnedOn==false?'(Off)': feature&&feature.SystemSettings?'('+feature.SystemSettings+' Settings)':''}}
          </option>
        </select>
        <span *ngIf="currentFeatureStatus">
          {{currentFeatureStatus.Description}}
        </span>
      </div>
      <div class="col-12 col-lg-7" *ngIf="currentFeatureStatus">
        <div class="round-15 p-3" [ngClass]="{'bg-success': currentFeatureStatus.TurnedOn, 'bg-danger': !currentFeatureStatus.TurnedOn}">
          <button class="btn btn-lg btn-primary  float-end" type="button" (click)="saveFeatureStatus(!currentFeatureStatus.TurnedOn)" [class.button-loading]="saving" [disabled]="loading">
            Turn {{currentFeatureStatus.TurnedOn ? 'Off' : 'On'}} Feature
          </button>
          <span class="fs-4">This feature is <b>{{currentFeatureStatus.TurnedOn ? 'enabled' : 'disabled'}}</b> for {{ currentClient?.BusinessName ||'this client' }}.</span><br />
          <span class="text-muted" *ngIf="currentFeatureStatus.InitialValue!=currentFeatureStatus.TurnedOn">This feature initial status is <b>{{ currentFeatureStatus.InitialValue ? 'enabled' : 'disabled'}}</b>.</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="settings" >
      <div class="row">
        <div *ngFor="let setting of settings" [class]="setting.getRowCss()">
          <div>
            <label for="setting_{{setting.SystemSetting}}">{{setting.SettingName}}</label>
          </div>
          <div *ngIf="setting.Description" class="text-muted">
            {{setting.Description}}
          </div>
          <div class="text-muted" *ngIf="!!setting.DefaultValue">Default value is <b>{{ setting.getDefaultValue() }}</b>.</div>

          <div *ngIf="setting.ImageThumbnail" class="center" >
                      <img [src]="setting.ImageThumbnail" class="img-fluid rounded mx-auto d-block "  />
          </div>
          <div class="input-group">
            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">{{getCompanyName(setting.CompanyID)}}</button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item active" href="javascript:void(0)" (click)="setting.setCompany(null)">Entreprise</a></li>
              <li><hr class="dropdown-divider"></li>
              <ng-container *ngFor="let company of companies">
                <li><a class="dropdown-item" href="javascript:void(0)" (click)="setting.setCompany(company.ID)">{{company.BusinessAbbreviation}}</a></li>
              </ng-container>
            </ul>

            <input *ngIf="setting.ShowTextInput" id="setting_{{setting.SystemSetting}}" class="form-control "
                   [type]="setting.getTextInputType()"
                   [placeholder]="setting.getPlaceholder()"
                   [(ngModel)]="setting.Value"
                   [disabled]="loading"
                   autocomplete="off" />

            <input *ngIf="setting.ShowNumberInput" id="setting_{{setting.SystemSetting}}" class="form-control text-end "
                   type="number"
                   [placeholder]="setting.getPlaceholder()"
                   [(ngModel)]="setting.IntValue"
                   [disabled]="loading"
                   autocomplete="off" />

            <input *ngIf="setting.ShowDateInput" id="setting_{{setting.SystemSetting}}" class="form-control text-center "
                   type="date"
                   [placeholder]="setting.getPlaceholder()"
                   [(ngModel)]="setting.DateValue"
                   [disabled]="loading"
                   autocomplete="off" />

            <input *ngIf="setting.ShowTimeInput" id="setting_{{setting.SystemSetting}}" class="form-control text-center "
                   type="time"
                   [placeholder]="setting.getPlaceholder()"
                   [(ngModel)]="setting.TimeValue"
                   [disabled]="loading"
                   autocomplete="off" />




            <select *ngIf="setting.ShowToggleInput" id="setting_{{setting.SystemSetting}}" class="form-control"
                    [(ngModel)]="setting.BitValue"
                    [disabled]="loading"
                    autocomplete="off">
              <option [ngValue]="null">-</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>

            <select *ngIf="setting.ShowSelectInput" id="setting_{{setting.SystemSetting}}" class="form-control"
                    [(ngModel)]="setting.IntValue"
                    [disabled]="loading"
                    autocomplete="off">
              <option *ngFor="let option of setting.getOptions()" [ngValue]="option.Value">{{option.Text}}</option>
            </select>

            <textarea *ngIf="setting.ShowTextAreaInput" class="form-control" rows="4"
                      [placeholder]="setting.getPlaceholder()"
                      [(ngModel)]="setting.Value"
                      [disabled]="loading"
                      autocomplete="off"></textarea>

            <p-autoComplete *ngIf="setting.ShowAutoCompleteInput" id="setting_{{setting.SystemSetting}}" class="form-control"
                            [(ngModel)]="setting.SelectedListItem"
                            [dropdown]="true"
                            dropdownMode="blank"
                            [forceSelection]="true"
                            [suggestions]="setting.filteredListItems"
                            (completeMethod)="setting.getListItems($event)"
                            optionLabel="Text"
                            autocomplete="off"
                            dataKey="Value"
                            minLength="0"></p-autoComplete>



            <input *ngIf="setting.ShowFileInput" id="setting_{{setting.SystemSetting}}" style="display:none;"
                   type="file"
                   [accept]="setting.getFileInputAcceptedValues()"
                   (change)="setting.upload($event.target)"
                   [disabled]="loading"
                   autocomplete="off" />

            <input *ngIf="setting.ShowFileInput" id="setting_{{setting.SystemSetting}}_text" class="form-control "
                   type="text" readonly="readonly"
                   [placeholder]="setting.getPlaceholder()"
                   [ngModel]="setting.Value"
                   [disabled]="loading"
                   autocomplete="off" />

            <button class="btn  btn-primary" type="button" (click)="setting.save()" [disabled]="loading"
                    [class.button-loading]="setting.saving">
              {{setting.ShowFileInput?'Upload':  'Save'}}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
